<template>
  <div :class="{ calrendarFlex: flexStyle == 'flex' }">
    <Calendar
            @onClickDay="onClickDay"
            :courseDate="times"
            :showRightSide="true"
            @onChangeDate="onChangeDate"
    ></Calendar>
    <div>
      <div class="list" v-if="list.length > 0">
        <div v-for="(item, index) in list" :key="index" class="item-list">
          <template v-if="item.periods_type == 20">
            <div class="item-card">
              <div class="left">
                <div class="time">
                  {{ item.live_time }}
                </div>
                <div
                        v-if="
                    !(
                      (item.status == 5 || item.status == 4) &&
                      item.show_answer_rule == 2
                    )
                  "
                        class="exam-state-wrap"
                >
                  <img :src="item.icon" />
                  <span>{{ item.statusText }}</span>
                </div>
              </div>
              <div class="line"></div>
              <ExamCard :test-info="item" />
            </div>
          </template>
          <template v-else>
            <template v-if="item.course_type != 0">
              <div class="item-card">
                <div class="left">
                  <div class="time">
                    {{ new Date(item.start_play * 1000).format("hh:mm") }}-{{
                    new Date(item.end_play * 1000).format("hh:mm")
                    }}
                  </div>
                  <div class="state-wrap">
                    <span
                            class="state"
                            :class="'state-' + item.live_status2"
                            v-if="
                        item.periods_type == 2 ||
                        item.periods_type == 3 ||
                        item.periods_type == 15
                      "
                    >
                      <span v-if="item.live_status2 == 1">未开始</span>
                      <span v-else-if="item.live_status2 == 2" class="living">
                        <span class="primary-color">{{item.course_type == 7?'上课中':'直播中'}}</span>
                      </span>
                      <span
                        v-else
                      >
                        <span>已结束</span>
                      </span>
                    </span>
                    <!-- <span
                            v-if="item.course_type == 7"
                            class="state"
                            :class="'state-' + item.live_status"
                    >
                      <span v-if="item.live_status == 0">未开始</span>
                      <span v-else-if="item.live_status == 1">
                        <span class="primary-color">上课中</span>
                      </span>
                      <span
                              v-else-if="
                          item.live_status == 2 ||
                          item.live_status == 3 ||
                          item.live_status == 4
                        "
                      >
                        <span>已结束</span>
                      </span>
                    </span> -->
                  </div>
                </div>
                <div class="line"></div>
                <div class="main">
                  <div class="main-line"></div>
                  <div class="main-content">
                    <div @click="showDialog(item)" style="cursor: default">
                      <span class="type">{{ item.course_type_name }}</span>
                      <span class="title">
                        <template v-if="item.type == 1">
                          <span
                                  v-if="item.chapter_title"
                                  style="margin-right: 12px"
                          >
                            {{ item.chapter_title }}
                          </span>
                        </template>
                        <template v-if="item.arrange_id">
                          <span
                                  v-if="item.classify_name"
                                  style="margin-right: 12px"
                          >
                            <span>{{ item.classify_name }}</span>
                          </span>
                          <span
                                  v-if="item.grade_name"
                                  style="margin-right: 10px"
                          >
                            <span>{{ item.grade_name }}</span>
                          </span>
                          <span v-if="item.sub_name">{{ item.sub_name }}</span>
                        </template>
                        <span v-else-if="item.course_type != 1">
                          {{ item.title }}
                        </span>
                        <span v-else>{{ item.teacher_name }}</span>
                      </span>
                    </div>
                    <div class="subtitle">
                      <span
                              class="class_name"
                              v-if="item.class && item.class.name"
                      >
                        {{ item.class.name }}
                      </span>
                      <span class="old_name" v-if="item.course_title">
                        {{ item.course_title }}
                      </span>
                      <span class="old_name" v-else-if="item.oto_desc">
                        {{ item.oto_desc }}
                      </span>
                      <template v-else-if="item.arrange_id">
                        <span class="old_name" v-if="item.teacher_name">
                          {{ item.teacher_name }}
                        </span>
                        <span class="old_name" v-if="item.province_name">
                          上课地点：{{ item.province_name }}{{ item.city_name
                          }}{{ item.district_name }}{{ item.address }}
                        </span>
                        <span class="old_name" v-if="item.room_name">
                          上课教室：{{ item.room_name }}
                        </span>
                      </template>
                    </div>
                    <template v-if="item.type == 1 || item.type == 2">
                      <FileList :fileList="item.notes || []" />
                    </template>
                    <template
                            v-if="
                        item.type != 1 &&
                        item.type != 2 &&
                        item.notes_status == 1
                      "
                    >
                      <FileList
                              :fileList="[
                          { ...item, ware_filename: item.notes_name },
                        ]"
                      />
                    </template>
                  </div>
                  <div class="live-state">
                    <template>
                      <span
                              class="text-disabled disabled"
                              v-if="
                          item.leave_status &&
                          item.leave_status == 3 &&
                          item.leave_allow &&
                          item.leave_allow != 1
                        "
                      >
                        请假驳回
                      </span>
                      <span
                              class="text-disabled disabled"
                              v-if="
                          item.leave_status &&
                          item.leave_status == 3 &&
                          item.leave_allow &&
                          item.leave_allow == 1
                        "
                      >
                        请假驳回，重新请假
                      </span>
                      <span
                              class="period-living"
                              @click="onLeave(item)"
                              v-if="item.leave_allow && item.leave_allow == 1"
                      >
                        请假
                      </span>
                      <span
                              class="text-disabled disabled"
                              v-if="item.leave_status && item.leave_status == 2"
                      >
                        已请假
                      </span>
                      <span
                              class="text-disabled disabled"
                              v-if="item.leave_status && item.leave_status == 1"
                      >
                        已请假，待审批
                      </span>
                    </template>
                    <template
                            v-if="
                        item.course_type == 1 ||
                        item.course_type == 2 ||
                        item.course_type == 3 ||
                        item.course_type == 15 ||
                        item.course_type == 16
                      "
                    >
                      <span
                              v-if="item.live_status2 == 1"
                              class="period-living"
                              @click.stop="goToPlay(item)"
                      >
                        立即进入
                      </span>
                      <span
                              v-else-if="item.live_status2 == 2"
                              class="period-living"
                              @click.stop="goToPlay(item)"
                      >
                        立即进入
                      </span>
                      <template v-else>
                        <span @click.stop="goToPlay(item)">
                          查看回放
                        </span>
                        <!-- <span
                                v-if="item.live_status == 3"
                                @click.stop="goToPlay(item)"
                        >
                          查看回放
                        </span>
                        <span
                                class="disabled"
                                v-else
                                :style="{ cursor: 'not-allowed' }"
                        >
                          查看回放
                        </span> -->
                      </template>
                    </template>
                    <template
                            v-else-if="item.arrange_id && item.buttons.length > 0"
                    >
                      <span @click.stop="onPeriodClick(item, item.buttons[0])">
                        {{ item.buttons[0].name }}
                      </span>
                      <span
                              v-if="item.buttons.length > 1"
                              class="more"
                              @click.stop="
                          hideAll();
                          item.showMore = true;
                        "
                      ></span>
                      <div v-if="item.showMore" class="more-panel">
                        <template v-for="(btn, index) in item.buttons">
                          <div
                                  v-if="index > 0"
                                  class="more-item"
                                  :key="btn.id"
                                  @click.stop="onPeriodClick(item, btn)"
                          >
                            {{ btn.name }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="item.course_type == 0">
              <MeetingCard
                      :item="getMeetingInfo(item)"
                      @goToPlay="goToMeeting"
              />
            </template>
          </template>
        </div>
      </div>
      <EmptyNew class="empty" title="暂无内容" v-else />
    </div>
    <CourseContentTip
            v-if="showContentDialog"
            :show.sync="showContentDialog"
            :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip
            v-if="showSoldOut"
            :show.sync="showSoldOut"
    ></CourseSoldOutTip>
    <MemberArrangeItem
            ref="arrange"
            v-show="false"
            :item="currentArrangeItem"
            :type="
        currentArrangeItem.type == 1 || currentArrangeItem.type == 2 ? 1 : 2
      "
            @leave="getData"
    ></MemberArrangeItem>
    <LeaveModal
            :show-modal.sync="showModal"
            :onLeaveSubmit="onLeaveSubmit"
            :period="leave.course"
    />
  </div>
</template>
<script>
  import Calendar from "@/components/Calendar.vue";
  import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
  import MeetingCard from "./classes/MeetingCard";
  import MemberArrangeItem from "@/modules/stu/views/periods/components/MemberArrangeItem.vue";
  import LeaveModal from "./classes/LeaveModal";
  import EmptyNew from "@/components/EmptyNew.vue";
  import FileList from "@/modules/stu/components/FileList";
  import CourseContentTip from "@/modules/stu/components/CourseContentTip";
  import * as enums from "@/utils/enums.js";
  import ExamCard from "./ExamCard";

  export default {
    name: "StudyCalendar",
    props: {
      timesUrl: {
        type: String,
        default: "/api/app/study/schedule",
      },
      dateUrl: {
        type: Function,
      },
      flexStyle: {
        type: String,
        default: "default",
      },
    },
    data() {
      return {
        showContentDialog: false,
        chapter_content: "",
        times: [],
        list: [],
        id: this.$route.params.id,
        showModal: false,
        leave: {
          course: {},
        },
        showSoldOut: false,
        time: 0,
        currentArrangeItem: {},
        hideMore: null,
        fileList: [],
        packageInfo: [
          {
            id: "submit_time",
            label: "交卷时间",
            value: "",
          },
          {
            id: "answer_time",
            label: "作答时长",
            value: "",
          },
        ],
        testInfo: [
          {
            id: "time",
            label: "答卷时长",
            value: "",
            unit: "分钟",
          },
          {
            id: "total_ques_num",
            label: "试题总数",
            value: "",
            unit: "道",
          },
          {
            id: "score",
            label: "考试总分",
            value: "",
            unit: "分",
          },
          {
            id: "pass_score",
            label: "通过分数",
            value: "",
            unit: "分",
          },
        ],
      };
    },
    components: {
      Calendar,
      CourseSoldOutTip,
      MemberArrangeItem,
      MeetingCard,
      LeaveModal,
      EmptyNew,
      FileList,
      CourseContentTip,
      ExamCard,
    },
    async created() {
      await this.getTimes();
      this.time = parseInt(new Date().getTime() / 1000);
      await this.getData();
      this.$emit("load");
    },
    mounted() {
      this.hideMore = () => {
        this.hideAll();
      };
      document.addEventListener("click", this.hideMore);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.hideMore);
    },
    methods: {
      isLive (start,end){//  1未开播  2直播中  3直播结束
        if(start==0){return 1}//未开播
        if(start!=0 && end==''){return 2}//直播中
        if(start!=0 && end!=''){return 3}//直播结束
      },
      showDialog(row) {
        if (row.periods_type == 7) {
          this.showContentDialog = true;
          this.chapter_content = row.content;
        }
      },
      getMeetingInfo(item) {
        let live_status;
        if (item.live_status == 0) {
          live_status = 1;
        } else if (item.live_status == 1) {
          live_status = 2;
        } else {
          live_status = 3;
        }
        return {
          ...item,
          start_time: item.start_play,
          end_time: item.end_play,
          live_status: live_status,
        };
      },
      //进入班会  id,type
      goToMeeting(data, type) {
        this.$livePlay(0, "meeting", {
          id: 0,
          title: data.meeting_name,
          meeting_id: data.id,
          type: type,
        });
      },
      //请假
      onLeave(course) {
        this.leave.course = course;
        this.showModal = true;
      },
      async onLeaveSubmit(leaveInfo) {
        await this.$http.post("/api/app/leave", {
          leave_cause: leaveInfo.content,
          class_id: this.id,
          course_id: this.leave.course.course_basis_id,
          course_periods_id: this.leave.course.periods_id,
          uid: this.$store.state.user_info.id,
        });
        await this.getData();
      },
      async getData() {
        let url;
        if (this.dateUrl) {
          url = this.dateUrl(this.time);
        } else {
          url = "/api/app/study/live/" + this.time;
        }
        let list = await this.$http.get(url);
        let ts = parseInt(new Date().getTime() / 1000);
        list.forEach(item => {
          // periods_type: 20 考试
          if (item.periods_type == 20) {
            item.status = this.getTestStatus(item.test_status, item).status;
            item.statusText = this.getTestStatus(
                    item.test_status,
                    item,
            ).statusText;
            // 未考试、未提交状态且过期的考试 展示已过期状态
            if (
                    item.has_expired &&
                    item.test_status != 3 &&
                    item.test_status != 2 &&
                    item.test_status != 1
            ) {
              item.status = 6;
              item.statusText = "已过期";
              item.icon = require("@/assets/images/calendar/exam-status-5.png");
            }
            item.icon = this.getTestStatus(item.test_status, item).icon;
            item.answer_time = this.$actionTool.timeMeter(item.answer_time, 3);
            item.submit_time = this.$actionTool.ts(
                    item.submit_time,
                    "yearminute",
            );
            item.time = item.time / 60; //答卷时长，单位是秒
            item.start_time = this.$actionTool.ts(item.start_time);
            item.end_time = this.$actionTool.ts(item.end_time);
            item.testInfo = this.testInfo.map(it => {
              if (it.id == "time" && !item[it.id]) {
                return {
                  ...it,
                  value: "不限制",
                  unit: "",
                };
              }
              return {
                ...it,
                value: item[it.id] || 0,
              };
            });
            item.packageInfo = this.packageInfo.map(it => {
              return {
                ...it,
                value: item[it.id],
              };
            });
          } else if (item.arrange_id) {
            item.course_type_name = enums.PeriodsType.getValue(item.type);
            if (ts < item.start_play) {
              item.live_status = 0;
            } else if (ts >= item.start_play && ts <= item.end_play) {
              item.live_status = 1;
            } else {
              item.live_status = 2;
            }

            



            item.is_leave = item.is_leave == 2 ? 1 : 0;
            item.showMore = false;
            item.buttons = [];
            if (item.attend_status == 1 && item.live_status == 2) {
              if (item.t_remark) {
                item.buttons.push({ id: "tremark", name: "查看老师评价" });
              }
              item.buttons.push({
                id: "sremark",
                name: item.s_remark ? "查看评价" : "评价",
              });
            }
          } else {
            item.mixType = item.course_type;
            item.course_type = item.periods_type || item.course_type;
            item.course_type_name = enums.CoursePeriodsType.getValue(
                    item.course_type,
            );
          }
          item.live_status2 = this.isLive(item.start_op_time,item.end_op_time)
        });
        this.list = list;
      },
      async onClickDay(date) {
        this.time = parseInt(new Date(date).getTime() / 1000);
        await this.getData();
      },
      async goToPlay(item, type) {
        if (item.status == 2 && item.is_go_to_study == 0) {
          this.showSoldOut = true;
          return;
        }
        if (item.course_type == 16) {
          if (!type) {
            type = 2;
          }
        } else if (!type) {
          type = 1;
        }
        if (type == 1 && (item.live_status == 2 || item.live_status == 4)) {
          return;
        }
        if (
                type == 2 &&
                (item.min_live_status == 2 || item.min_live_status == 4)
        ) {
          return;
        }
        if (item.valid_status != 1) {
          return this.$info("该课程已过期，无法继续学习");
        }
        if (item.course_type != 1) {
          await this.$services.CourseService.checkLimit(item.course_basis_id);
        }

        console.log(item,'555555555555555555555555555')
        //查询
        if (item.course_type  ==2 && item.periods_type  ==2){
       console.log(item.room_video_id,'房间号')

      let  data11 =   await this.$http.get("/api/app/getBycourse_chapter_id", {
        course_basis_id: item.course_basis_id,
        room_video_id: item.room_video_id,
 });

 console.log(data11);
 console.log(data11.course_chapter_id,'88888888888')

          this.$livePlay(item.course_basis_id, item.course_type, {
            id: data11.course_chapter_id,
            title: item.title,
            type: type,
            period_id: item.periods_id,
          });
        }else {
          this.$livePlay(item.course_basis_id, item.course_type, {
            id: item.course_chapter_id,
            title: item.title,
            type: type,
            period_id: item.periods_id,
          });
        }

      },
      async onPeriodClick(item, button) {
        this.currentArrangeItem = item;
        await this.$nextTick();
        if (button.id == "play") {
          this.$refs.arrange.onPlay();
        } else if (button.id == "notes") {
          this.$refs.arrange.onDownload(item);
        } else if (button.id == "leave") {
          this.$refs.arrange.onLeave();
        } else if (button.id == "tremark") {
          this.$refs.arrange.onTeacherComment();
        } else if (button.id == "sremark") {
          this.$refs.arrange.onComment();
        }
        this.hideAll();
      },
      hideAll() {
        this.list.forEach(item => {
          item.showMore = false;
        });
      },
      getTestStatus(type, data) {
        switch (type) {
          case -1:
            return {
              status: 1,
              statusText: "待考试",
              icon: require("@/assets/images/calendar/exam-status-1.png"),
            };
          case 0:
            return {
              status: 2,
              statusText: "待提交",
              icon: require("@/assets/images/calendar/exam-status-2.png"),
            };
          case 2:
            return {
              status: 3,
              statusText: "待批阅",
              icon: require("@/assets/images/calendar/exam-status-3.png"),
            };
          case 1:
          case 3: //没有设置人工审批，提交就是已提交
            if (data.is_pass == 2) {
              return {
                status: 5,
                statusText: "未通过",
                icon: require("@/assets/images/calendar/exam-status-6.png"),
              };
            }
            return {
              status: 4,
              statusText: "已通过",
              icon: require("@/assets/images/calendar/exam-status-4.png"),
            };
        }
      },
      // 月份改变
      onChangeDate(date) {
        this.getTimes(date);
      },
      // 获取标注日期
      async getTimes(date) {
        let query = {};
        if (date) {
          query = {
            date: date,
          };
        }
        this.times = await this.$http.get(this.timesUrl, query);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .list {
    padding: 35px 24px 30px 0;
  }
  .item-list {
    &:last-child {
      /deep/ .line::after {
        display: none !important;
      }
      /deep/ .main {
        margin-bottom: 0 !important;
      }
      /deep/ .main-wrap {
        margin-bottom: 0 !important;
      }
    }
  }
  .item-card {
    display: flex;
    //&:last-child {
    //  .line::after {
    //    display: none;
    //  }
    //  .main {
    //    margin-bottom: 0;
    //  }
    //}
    .left {
      margin-right: 16px;
      margin-top: 18px;
      width: 115px;
    }
    .main {
      flex: 1;
      display: flex;
      align-items: center;
      margin-bottom: 35px;
      border: 1px solid #e6e6e6;
      border-left: none;
      padding: 18px 16px 18px 18px;
      position: relative;
    }
    .main-line {
      position: absolute;
      height: 100%;
      width: 4px;
      left: 0;
      top: 0;
      background: #f39b10;
    }
    .main-content {
      flex: 1;
    }
    .time {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      height: 22px;
      line-height: 22px;
      display: flex;
      justify-content: flex-end;
    }
    .line {
      position: relative;
      width: 10px;
      margin: 0 24px 0 0;

      &::before {
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        box-sizing: border-box;
        border: 2px solid #f39b10;
        border-radius: 50%;
        background: #fce6c3;
        z-index: 1;
        top: 24px;
      }
      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 100%;
        box-sizing: border-box;
        border-left: 2px dashed #dadada;
        left: 4px;
        top: 30px;
      }
    }
    .type {
      font-size: 12px;
      color: $primary-color;
      background: $primary-color-light;
      padding: 3px 6px;
      border-radius: 4px;
      margin-right: 8px;
    }
    .type-arrange {
      font-size: 12px;
      color: #ec8e0f;
      background: #fff5dc;
      padding: 3px 6px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .exam-state-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-top: 2px;
      img {
        width: 16px;
        height: 16px;
      }
      span {
        margin-left: 4px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        color: #999999;
        line-height: 20px;
      }
    }
    .state-wrap {
      display: flex;
      justify-content: flex-end;
      padding-top: 2px;
    }
    .state {
      font-size: 14px;
      color: #999999;
      padding-left: 20px;
      background-image: url("~@/assets/images/calendar/end@2x.png");
      background-repeat: no-repeat;
      background-size: 16px 16px;
      background-position: left center;
    }
    .state-1 {
      background-image: url("~@/assets/images/calendar/wait@2x.png");
    }
    .state-2 {
      background-image: url("~@/assets/images/calendar/living@2x.png");
    }
    .living {
      color: $primary-color;
    }
    .title {
      font-size: 14px;
    }
    .subtitle {
      color: #999999;
      margin-top: 8px;
    }
    .subtitle-line {
      margin: 0 8px;
      color: #d8d8d8;
    }
    .class_name {
      background: url("~@/assets/images/class_name.png") no-repeat 100% 3px;
      background-size: 1px 14px;
      padding-right: 8px;
      margin-right: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 260px;
      display: inline-block;
      vertical-align: top;
    }
    .old_name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 260px;
      display: inline-block;
      vertical-align: top;
    }
    .live-state {
      display: flex;
      position: relative;
      span {
        font-size: 14px;
        border: 1px solid #bfbfbf;
        cursor: pointer;
        border-radius: 19px;
        margin-left: 10px;
        padding: 7px 20px;
        &:first-child {
          margin-left: 0;
        }
        &:hover {
          border-color: $primary-color;
          color: $primary-color;
        }
        &.disabled {
          color: #333333;
          background: #f5f5f5;
          opacity: 0.5;
          cursor: not-allowed !important;

          &:hover {
            background: #f5f5f5;
            color: #333333;
            cursor: default;
            border-color: #bfbfbf;
          }
        }
      }
      .text-disabled {
        position: relative;
        top: 2px;
        border: none;
        cursor: default;
        vertical-align: middle;
        &.disabled {
          color: #999;
          background: #fff;
          &:hover {
            background: #fff;
            color: #999;
            cursor: default;
          }
        }
      }
      .more {
        width: 36px;
        padding: 0;
        text-align: center;
        line-height: 34px;
        background: url("~@/assets/images/calendar/more@2x.png") no-repeat center
        center/16px 4px;
      }
      .more-panel {
        position: absolute;
        right: 0;
        top: 40px;
        width: 128px;
        padding: 4px 0;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      }
      .more-item {
        height: 36px;
        padding-left: 12px;
        line-height: 36px;
        cursor: pointer;
        &:hover {
          background: $primary-color-light;
          color: $primary-color;
        }
      }
    }
  }
</style>
